import React, { Component } from "react";
import { Steps, Alert } from "antd";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";

import { PostData } from "../../api/service";
import AdmissionPrintIdentifyStep from "./AdmissionPrintIdentifyStep";
import AdmissionPrintForm from "./AdmissionPrintForm";

const { Step } = Steps;

export default class AdmissionPrintRequest extends Component {
  state = {
    step: 0,
    student: null,
    receipts: [],
    isSubmitting: false
  };

  onFound = (resp, roll_no, email) => {
    this.setState({
      step: 1,
      student: {
        student_id: resp.student_id,
        name: resp.name,
        roll_no: roll_no,
        email: email,
        phone: resp.phone
      },
      receipts: Array.isArray(resp.receipts) ? resp.receipts : []
    });
  };

  onSubmit = (payload) => {
    this.setState({ isSubmitting: true });

    PostData("/add-admission-print-request", payload)
      .then((resp) => {
        this.setState({ isSubmitting: false });

        if (resp && resp.status === true) {
          confirmAlert({
            title: "Successfully Submitted ! Proceed to Payment Now.",
            message: "You will now be taken to the payment page.",
            buttons: [
              {
                label: "Proceed to Payment",
                onClick: () =>
                  this.goToPayment(resp.admission_print_request_id, resp.email)
              }
            ]
          });
        } else if (resp && resp.recaptcha_failed) {
          alert(resp.status_text);
        } else if (resp && resp.admission_print_request_id) {
          // an unpaid request already exists for this receipt — send them there
          // rather than creating a duplicate
          confirmAlert({
            title: "Previous unsettled request found",
            message: resp.status_text,
            buttons: [
              {
                label: "Proceed to Payment",
                onClick: () =>
                  this.goToPayment(resp.admission_print_request_id, resp.email)
              }
            ]
          });
        } else {
          alert(
            resp && resp.status_text
              ? resp.status_text
              : "Could not submit your request."
          );
        }
      })
      .catch(() => {
        this.setState({ isSubmitting: false });
        alert("Something went wrong. Please try again.");
      });
  };

  goToPayment = (id, email) => {
    window.location.href = `/admission-print-payment?admission_print_request_id=${id}&email=${encodeURIComponent(email)}`;
  };

  render() {
    return (
      <div>
        <Steps current={this.state.step} size="small" style={{ marginBottom: 20 }}>
          <Step title="Identify" />
          <Step title="Choose Receipt" />
          <Step title="Payment" />
        </Steps>

        {this.state.step === 0 && (
          <AdmissionPrintIdentifyStep onFound={this.onFound} />
        )}

        {this.state.step === 1 && this.state.student && (
          <div>
            <Alert
              type="success"
              showIcon
              message={`Found: ${this.state.student.name} (${this.state.student.roll_no})`}
            />
            <br />

            <AdmissionPrintForm
              student={this.state.student}
              receipts={this.state.receipts}
              isSubmitting={this.state.isSubmitting}
              onSubmit={this.onSubmit}
            />
          </div>
        )}
      </div>
    );
  }
}
